<div class="kontainer" #kontainer>
  <div class="skrollkontainer" #skrollkontainer [class.dra-og-slipp-pågår]=" draOgSlippPaagaar()">
    @if (!ingenMoeter()) {
      @for (innslag of innslag(); track innslag.id) {
        <!-- merk at vi bruker mouseup og ikke click for å kunne avbryte 'klikk' dersom en dra-og-slipp handling pågår -->
        <horisontal-moetenavigasjon-innslag [innslag]="innslag"
                                            [aktiv]="aktivtMoeteId() != null && innslag.moeteinfo()?.id == aktivtMoeteId()"
                                            [bredde]="innslagBredde"
                                            [smalVisning]="smalVisning()"
                                            [smalVisningEkspandert]="smalVisningEkspandert()"
                                            (mouseup)="vedKlikkPaaInnslag(innslag, $event)"
                                            (vedSynlig)="vedInnslagSynlig(innslag)"/>
      }
    }
  </div>
  <div class="vis-tidligere">
    <button mat-icon-button (click)="visTidligere()">
      <mat-icon>arrow_backward</mat-icon>
    </button>
  </div>
  <div class="vis-senere">
    <button mat-icon-button (click)="visSenere()">
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>

  @if (ingenMoeter() && this.initialisert()) {
    <div class="ingen-møter" data-testid="ingen-møter">
      <tips forsinketVisning="true">
        {{ 'Ingen møter'|translate }} -
        <a (click)="gaaTilOpprettMoete()">opprett ditt første møte</a>.
      </tips>
    </div>
  }
</div>
